import React from 'react';
import { stub } from '@xsk/frontend-skeleton';

class SalesData extends React.Component {
    render() {
        const selectOptions = {
            selectable: true,
            selectType: 'checkbox'
        };
        return (
            <stub.ui.ListPage
                module='collection'
                {...this.props}
                fixable={true}
                selectOptions={selectOptions}
                listMetadataKey='collection-salesData-list'
                filterMetadataKey='collection-salesData-filter' />
        )
    }

}

export default SalesData;
